import { ANGULAR_PREFIX, EXTENSION_FRAME_ID } from '../constants';

export function injectScriptWithIframe(
  tag: string,
  scriptPaths: string[],
  stylesPaths?: string[],
  attributes?: Record<string, string>,
): void {
  const node = document.getElementsByTagName(tag)[0];
  const elementTagName = `${ANGULAR_PREFIX}-extension`;

  const existingIFrame = document.getElementById(EXTENSION_FRAME_ID);
  if (existingIFrame) {
    existingIFrame.remove();
  }

  // Create an iframe to isolate the extension content
  const iframe: HTMLIFrameElement = document.createElement('iframe');
  iframe.id = EXTENSION_FRAME_ID;
  iframe.src = 'about:blank';
  iframe.style.border = 'none';
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.zIndex = '100000';
  iframe.style.position = 'fixed';
  iframe.style.display = 'none';
  iframe.style.left = '0px';
  iframe.style.right = '0px';
  iframe.style.top = '0px';
  iframe.style.bottom = '0px';

  // Wait for the iframe to load before injecting scripts and styles
  iframe.onload = () => {
    // Ensure the iframe has a contentDocument
    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDocument) return;

    // Check if the elementTagName already exists inside the iframe
    if (iframeDocument.getElementsByTagName(elementTagName).length === 0) {
      // Create the custom element inside the iframe
      const customElement = iframeDocument.createElement(elementTagName);

      customElement.setAttribute('assets', chrome.runtime.getURL('assets'));
      // Set attributes if available
      if (attributes) {
        for (const [key, value] of Object.entries(attributes)) {
          customElement.setAttribute(key, value);
        }
      }
      iframeDocument.body.appendChild(customElement);
    }

    // Inject the styles.css file as a link element into the iframe
    if (stylesPaths) {
      stylesPaths.forEach((path: string) => {
        const linkElem = iframeDocument.createElement('link');
        linkElem.setAttribute('rel', 'stylesheet');
        linkElem.setAttribute('href', path);
        iframeDocument.head.appendChild(linkElem);
      });
    }

    // Inject the script file into the iframe
    scriptPaths.forEach((path: string) => {
      const script = iframeDocument.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', path);
      iframeDocument.body.appendChild(script);
    });
  };

  // Append the iframe to the node
  node.appendChild(iframe);
}

export function injectStyles(stylesPaths?: string[]): void {
  if (!stylesPaths) {
    return
  };
  stylesPaths.forEach((path: string) => {
    const linkElem = document.createElement('link');
    linkElem.setAttribute('rel', 'stylesheet');
    linkElem.setAttribute('href', path);
    document.head.appendChild(linkElem);
  });
}
